module.exports = __webpack_public_path__ + "static/media/handshake.9aff9718.jpg";